import React, { useState } from 'react';
import styled from 'styled-components';

interface Tab {
  id: string;
  label: string;
  content: React.ReactNode;
}

interface TabsProps {
  tabs: Tab[];
  defaultTab?: string;
}

interface StyledTabButtonProps {
  isActive: boolean;
}

interface StyledTabContentProps {
  isActive: boolean;
}

const TabsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const TabButton = styled.div<StyledTabButtonProps>`
  padding: 12px 20px;
  cursor: pointer;
  background: ${(props: StyledTabButtonProps) => (props.isActive ? '#4F728F' : '#6A89A6')};
  color: white;
  margin: 0 5px;
  border-radius: 5px;
  transition: all 0.3s ease-in-out;

  &:hover {
    background: #5E85A2;
  }
`;

const TabContent = styled.div<StyledTabContentProps>`
  display: ${(props: StyledTabContentProps) => (props.isActive ? 'block' : 'none')};
  padding: 20px;
  background: white;
  border-radius: 5px;
  margin: 10px auto;
  max-width: 80%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const Tabs: React.FC<TabsProps> = ({ tabs, defaultTab }) => {
  const [activeTab, setActiveTab] = useState(defaultTab || tabs[0].id);

  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId);
  };

  return (
    <>
      <TabsContainer>
        {tabs.map((tab) => (
          <TabButton
            key={tab.id}
            isActive={activeTab === tab.id}
            onClick={() => handleTabClick(tab.id)}
          >
            {tab.label}
          </TabButton>
        ))}
      </TabsContainer>
      {tabs.map((tab) => (
        <TabContent key={tab.id} isActive={activeTab === tab.id}>
          {tab.content}
        </TabContent>
      ))}
    </>
  );
};

export default Tabs; 